import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type SlideOverContentWrapperProps = PropsWithChildren<{
  className?: string;
  isScrollable?: boolean;
}>;

export const SlideOverContentWrapper: FC<SlideOverContentWrapperProps> = ({ children, className, isScrollable = true }) => (
  <div className={twMerge('flex flex-col flex-grow gap-6 pr-4', isScrollable && 'overflow-y-auto brand-scrollbar', className)}>{children}</div>
);
